const key = 'optimeet_ipse_session_id';

export const getSession = () => {
	return localStorage.getItem(key) || undefined
}
